const css = require('./header.css');
const Price = require('../price');
const ordersComputedActions = require('../../../../../actions/computed/account/orders');
const currentOrderActions = require('../../../../../actions/account/current-order');

class Header {
    constructor () {
        this.template = require('./template.hbs');
    }

    render () {
        const props = this.$context.props;

        return this.$context.getWatcherData().then((data) => Object.assign({}, data, props, { css }));
    }
}

module.exports = {
    constructor: Header,
    children: [
        {
            name: 'price',
            component: Price,
            watcher: {
                isShowAsterisk: ordersComputedActions.PATHS.isShowSumCanChangeTooltip,
                rowPrice: ['account', 'orders', 'computed', 'price', 'data', 'total', 'rowPrice'],
                totalPrice: ['account', 'orders', 'computed', 'price', 'data', 'total', 'totalPrice'],
                orderAmount: currentOrderActions.PATHS.orderAmount,
                rowAmount: ['account', 'orders', 'computed', 'price', 'data', 'total', 'rowAmount'],
                isLoading: ['account', 'orders', 'computed', 'price', 'isLoading'],
                typeId: ['account', 'orders', 'currentOrder', 'typeId']
            }
        }
    ]
};



// WEBPACK FOOTER //
// ./components/account/orders/current-order/header/index.js